import { fetcher, methods } from 'common/apis'
import {
  DELETE_PUBLIC_QUESTIONS_ENDPOINT,
  PUBLIC_QUESTIONS_ENDPOINT,
  ANSWER_PUBLIC_QUESTION_ENDPOINT,
} from 'common/constants'
import { API_HOST_URL } from 'components/constants'

const DELETE_PUBLIC_QUESTION = `${API_HOST_URL}${DELETE_PUBLIC_QUESTIONS_ENDPOINT}`
const LIST_PUBLIC_QUESTIONS = `${API_HOST_URL}${PUBLIC_QUESTIONS_ENDPOINT}`
const ANSWER_PUBLIC_QUESTION = `${API_HOST_URL}${ANSWER_PUBLIC_QUESTION_ENDPOINT}`

export const listPublicQuestions = async (limit: number, skip: number, q: string = "") => {
  const { data, error } = await fetcher(`${LIST_PUBLIC_QUESTIONS}`, methods.POST, { limit, skip, q })
  return { data, error }
}

export const deletePublicQuestion = async ({
  productId,
  questionId,
}: {
  productId: string
  questionId: string
}) => {
  const { data, error } = await fetcher(
    `${DELETE_PUBLIC_QUESTION}/${productId}/${questionId}`,
    methods.DELETE
  )
  return { data, error }
}

export const answerPublicQuestion = async ({
  productId,
  questionId,
  answer,
  adminName,
}: {
  productId: string
  questionId: string
  answer: string
  adminName: string
}) => {
  const { data, error } = await fetcher(
    `${ANSWER_PUBLIC_QUESTION}/${productId}/${questionId}`,
    methods.PATCH,
    { answer, adminName }
  )
  return { data, error }
}